import api from 'Api'
import { SET_MESSAGE } from '../components/utils'

const URL = '/principal'

const state = {
  collectorPrinciples: [],
  collectorServers: []
}

const getters = {
  collectorPrinciples: state => {
    return state.collectorPrinciples
  },
  collectorServers: state => {
    return state.collectorServers
  },
  getCollectors: (state, getters, rootState, rootGetters) => {
    return rootGetters.collectors
  }
}

const actions = {
  async addPrincipal (context, payload) {
    let response
    try {
      response = await api().post(URL, {
        collector_id: payload.collector_id,
        organization_id: payload.organization_id,
        password: payload.password,
        name: payload.name,
        server: payload.server
      })
      context.commit('SET_COLLECTOR_PRINCIPLES', [response.data])
      context.commit('Add_COLLECTORS_SERVER', response.data.server)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      return
    }
    if (response && response?.data?.error) {
      SET_MESSAGE({ type: 'error', message: response?.data?.error })
      return
    }
    SET_MESSAGE({ type: 'success', message: 'Principal is Saved' })
    return response
  },
  async getCollectorDetails (context, payload) {
    context.commit('RESET_COLLECTOR_PRINCIPLE')
    let response
    try {
      response = await api().get(`${URL}/collector/${payload.collector_id}`)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      return
    }
    context.commit('SET_COLLECTOR_PRINCIPLES', response.data)
    return response
  },
  async getAllServers (context) {
    const collectors = context.getters.getCollectors
    let response
    try {
      let data = []
      const requests = collectors && collectors.map(collector => api().get(`${URL}/collector/${collector.entity_id}`))
      response = await Promise.all(requests).then(responses => {
        responses.forEach(res => {
          data = [...data, ...res.data]
        })
      })
      context.commit('SET_COLLECTORS_SERVERS', data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      return
    }
    return response
  }
}

const mutations = {
  RESET_COLLECTOR_PRINCIPLE (state) {
    state.collectorPrinciples = [{
      name: 'None'
    }]
  },
  SET_COLLECTOR_PRINCIPLES (state, collectorPrinciples) {
    state.collectorPrinciples.push(...collectorPrinciples)
  },
  SET_COLLECTORS_SERVERS (state, data) {
    const servers = data && data.map(item => item.server)
    console.log('SET_COLLECTOR_SERVERS', servers)
    state.collectorServers = servers
  },
  Add_COLLECTORS_SERVER (state, data) {
    state.collectorServers.push(data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'principalServices'
}
